<template>
  <v-card>
    <v-card-text>
      <v-expansion-panels multiple>
        <v-expansion-panel v-test="{ panel: '' }">
          <v-expansion-panel-header>
            <div id="info">
              <v-icon>
                info
              </v-icon>
              {{ $t('Информация о пользователе') }}
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content eager>
            <user-profile-view
                :profile-info="profileInfo" />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <slot name="additional" />
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
  import UserProfileView from './UserProfileView.vue'
  export default {
    components: {
      UserProfileView
    },
    props: {
      profileInfo: {
        type: Object,
        required: true
      },
      documents: {
        type: Array,
        default: () => {
          return []
        }
      }
    }
  }
</script>
